import { Box } from "@mui/material";
import HeroParallaxSection from "../components/sections/HeroParallaxSection";
import { peopleContent } from "../data/peopleContent";
import PeopleGrid from "../components/common/PeopleGrid";
import SectionYellowTitle from "../components/common/SectionYellowTitle";
import WhyWorkAtHungerford from "../components/common/WhyWorkAtHungerford";

const PeoplePage: React.FC = () => {
  const { title, headline, intro, images, description1 } = peopleContent;

  return (
    <>
      <HeroParallaxSection
        sectionLabel={title}
        subtitle={headline}
        showButton={false}
        showTitleResponsive={true}
        backgroundImage={images[0].imageSrc}
      />
      <Box
        sx={{
          maxWidth: "1050px",
          mx: "auto",
          px: { xs: 3, md: 3, lg: 0 },
          py: { xs: 1, md: 2, lg: 4 },
        }}
      >
        {/* Description section */}
        <Box>
          <WhyWorkAtHungerford
            heading={intro}
            content={description1}
            imageSrc={images[1].imageSrc}
            imageAlt={images[1].imageAlt}
            maxWidth="2050px"
            textWidth="2000px"
            alignTextVertical="top"
          />
        </Box>
        {/* Our People section */}
        <SectionYellowTitle title="Our Team" marginBottom={6} marginTop={10} />
        <PeopleGrid />
      </Box>
    </>
  );
};
export default PeoplePage;
